import React, { useState, useRef, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory, useLocation } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getPersonInfoById, getPersonsَArchive } from '../../service/personService';
import AreaModal from '../shared/AreaModal';
import LoadingBar from '../shared/LoadingBar';
import LoadingSpinner from '../shared/LoadingSpinner';
import kiImage from './../container/image/ki.png';
import Person from './person';
import './persons.css';
import { getAllArea } from './../../service/areaService';
import { useToasts } from 'react-toast-notifications';

const Persons = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [areas, setAreas] = useState();
    const [areaLoading, setAreaLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    
    const [persons, setPersons] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [searchInput, setSearchInput] = useState('');
    const [lastItemId, setLastItemId] = useState('');
    const [hasMore, setHasMore] = useState(true);

    const [area, setArea] = useState({_id: 'all', title: 'کل مشهد'});
    const [category] = useState(() => {
        if(state && state.category)
        return state.category;
        else
        return {_id: 'all', title: '*** همه ***'}
    });

    const personsRef = useRef(null);
    const personsCountRef = useRef(null);

    const onSearchHandler = (event) => {
        personsRef.current = null;
        personsCountRef.current = null;
        let searched = event.target.value;
        setSearchInput(searched);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    useEffect(() => {
        if (persons && personsCountRef && personsCountRef.current <= persons.length) {
            setHasMore(false);
        }
    }, [persons, personsCountRef]);

    const fetchMoreData = async () => {
        const lastItemId = persons[persons.length - 1]._id;
        setLastItemId(lastItemId);
    };

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllPersons = async () => {
            try {
                let params = { 
                    id: lastItemId, 
                    searchText: searchInput,
                    categoryId: category._id,
                    areaId: area._id
                }
                let { status, data } = await getPersonsَArchive(params, { cancelToken: cancelRequest.signal });

                if (status === 201) {
                    personsCountRef.current = data.counts;

                    if (personsRef.current) {
                    personsRef.current = personsRef.current.concat(data.persons);
                    setPersons(personsRef.current);

                    }
                    else {
                        personsRef.current = data.persons;
                        setPersons(personsRef.current);
                    }
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchAllPersons();
        return () => {
            cancelRequest.cancel();
        }
    }, [searchInput, lastItemId, area, category]);

    const fetchAllAreas = async () => {
        try {
            setAreaLoading(true);
            let { status, data } = await getAllArea({});
            if(status === 201){
                data.areas.unshift({_id: 'all', title: 'کل مشهد'});
                setAreas(data.areas)
                setAreaLoading(false);
                setShowModal(true)
            }
        } catch (err) {

        }
    }

    const setAreaHandler = (area) => {
        personsRef.current = null;
        personsCountRef.current = null;
        setHasMore(true);
        setLastItemId('');
        setArea(area);
        setIsLoading(true);
    }

    const { addToast } = useToasts();
    const[fetchLoadingSpinner, setFetchLoadingSpinner] = useState({flag: false, id:''});

    const fetchPerson = async (personId) => {
        try {

            setFetchLoadingSpinner({flag: true, id: personId});
            let { status, data } = await getPersonInfoById(personId, {});
            if(status === 201){
                setFetchLoadingSpinner({flag: false, id:''});
                history.push(`/who/person/info/${personId}`, 
                { person: data.person, jobCategoryName: category.title}
                );
            }

        } catch (err) {
            if(err.response && err.response.status === 404){
                addToast("چنین کاربری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/who')
            }
        }
    } 

    return ( 
        <div className="persons-layer-archive">
            <div className="container">
                <header className="">
                    <div className="">
                        <img src={kiImage} alt="" className="main-image-top"/>
                        <small className="font-weight-bold ki-link"
                            onClick={() => history.replace('/who')}
                        >
                            کی خوبه ؟ ( تأسیسات ، تعمیرات ) / 
                        </small>
                        <small className="font-weight-bold">{category.title}</small>
                    </div>
                    <div className="d-flex justify-content-start  align-items-center mt-2">
                        <div className="mt-1">
                            <button 
                                className="btn btn-outline-success py-1 rounded-pill"
                                disabled={areaLoading}
                                onClick={fetchAllAreas}
                            >
                                <i 
                                    className={
                                        areaLoading ? 
                                        'spinner-border spinner-border-sm mr-2 mb-1':
                                        'fa fa-filter  mr-1'
                                    } 
                                ></i>
                                {area.title}
                            </button>
                            <AreaModal 
                                setArea={setAreaHandler}
                                areas={areas}
                                show={showModal}
                                onCancel={() => setShowModal(false)}
                            />
                        </div>
                        <div>
                            <div className="d-flex mx-md-0 search-ki-category mt-2 ">
                                <span className="">
                                    <i className="fa fa-search"></i>
                                </span>
                                <input
                                    type="text"
                                    placeholder="جستجو کنید"
                                    className="col inline-block form-control"
                                    onChange={onSearchHandler}
                                    value={searchInput}
                                />
                            </div>
                        </div>
                    </div>
                </header>  
                <section>
                        {
                            (isLoading || !persons) ?
                            <div style={{ height: '60vh' }} className="d-flex">
                                <div className="text-center align-self-center mx-auto">
                                    <LoadingSpinner />
                                </div>
                            </div>
                            :
                            <InfiniteScroll
                                dataLength={persons && persons.length}
                                next={fetchMoreData}
                                hasMore={hasMore}
                                loader={
                                    <div className="d-flex mt-2">
                                        <span className="mx-auto">
                                            <LoadingBar
                                                type="spinningBubbles"
                                                color="#0eac1b"
                                            />
                                        </span>
                                    </div>
                                }
                                endMessage={
                                    <p className="text-center mt-3">
                                    </p>
                                }
                            >
                                <div className="persons-list-layer">
                                    {
                                        persons.map(person => 
                                            <Person 
                                                key={person._id}
                                                personId={person._id}
                                                code={person.code}
                                                vocation={person.vocation}
                                                areaName={person.areaName}
                                                image={person.personImage}
                                                score={person.score}
                                                getPersonInfo={() => fetchPerson(person._id)}
                                                fetchLoading={fetchLoadingSpinner}

                                            />  
                                        ) 
                                    }
                                </div>
                            </InfiniteScroll>
                        }
                </section>  
            </div>
        </div>
     );
}
 
export default Persons;